import { mapMutations, mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import RedirectPayloadError from '@/errors/errors';
import { expiresDateFormatting } from '@/helpers/expiresDateFormatting';
import { v4 as uuid } from 'uuid';
export default {
  data() {
    return {
      showInvoiceView: false,
    };
  },

  computed: {
    ...mapState(['invoiceInitialData', 'flowData']),
  },

  methods: {
    ...mapMutations(['SET_CURRENT_STEP', 'SET_INVOICE_FLOW_DATA_SHOWN']),

    async makeInvoiceFlowPayment(payment_service, fields) {
      this.SET_CURRENT_STEP(2);
      this.isLoadingInvoiceFlow = true;
      if (fields === undefined) fields = {};

      const {
        currency,
        public_key,
        amount,
        description = new Date(),
        expires = null,
        metadata = null,
        reference_id = null,
      } = this.invoiceInitialData;

      const { code } = payment_service;

      let data = {
        public_key,
        reference_id: reference_id ? reference_id : uuid(),
        service: code,
        currency,
        amount,
      };

      if (description && description.length) {
        data.description = description;
      }

      if (expires && expires.length) {
        data.expires = expiresDateFormatting(expires);
      }

      if (metadata) {
        data.metadata = metadata;
      }

      if (Object.keys(fields).length > 0) {
        data.service_fields = cloneDeep(fields);
      }

      try {
        await this.createPaymentInvoice(data);

        if (!this.flowData.payload) {
          throw new RedirectPayloadError('no-payload-data');
        }

        this.isLoadingInvoiceFlow = false;
        this.SET_INVOICE_FLOW_DATA_SHOWN(true);

        return Promise.resolve();
      } catch (e) {
        this.SET_CURRENT_STEP(1);
        this.isLoadingInvoiceFlow = false;
        throw e;
      } finally {
      }
    },
  },
};
